<template>
    <div class="md-layout">
        <div class="md-layout-item">
            <md-card>
                <md-card-header class="md-card-header-icon md-card-header-warning">
                    <div class="card-icon">
                        <md-icon>draft</md-icon>
                    </div>
                </md-card-header>
                <div class="bulk-section" v-if="this.selectedTeamMemberInvoiceIds.length && !isTeamMember">
                    <div>
                        {{ this.selectedTeamMemberInvoiceIds.length }} invoice{{
                            this.selectedTeamMemberInvoiceIds.length > 1 ? 's' : ''
                        }}
                        selected.
                    </div>
                    <div>
                        <approve-invoice-button
                            v-if="!isReadOnlyUser"
                            :is-bulk="true"
                            :bulk-team-member-invoice-ids="selectedTeamMemberInvoiceIds"
                            @invoiceBulkApprove="handleBulkApprove"
                        />

                        <send-draft-invoice-button
                            v-if="!isReadOnlyUser && !isTeamMember"
                            v-feature="FEATURE_NAMES.TeamMemberInvoiceDraftApproval"
                            :bulk-team-member-invoice-ids="selectedTeamMemberInvoiceIds"
                            @bulkDraftInvoicesSent="updateBulkDraftInvoice"
                            :is-bulk="true"
                            class="bulk-send-draft"
                        />

                        <delete-invoice-button
                            :is-bulk="true"
                            :bulk-team-member-invoice-ids="selectedTeamMemberInvoiceIds"
                            @invoiceBulkDelete="handleBulkDelete"
                        />
                    </div>
                </div>
                <div>
                    <md-table
                        :class="['context-menu-support', 'custom-paginated-table', { 'table-margin': isListLoading }]"
                    >
                        <md-table-row>
                            <md-table-head>
                                <md-checkbox
                                    class="shipment-checkbox checkbox-head"
                                    v-model="isSelectAll"
                                    @change="onSelectAll(isSelectAll)"
                                />
                            </md-table-head>
                            <md-table-head v-if="!$root.isDesktop">Status</md-table-head>
                            <md-table-head>Invoice Number</md-table-head>
                            <md-table-head v-if="$root.isDesktop">Team Member</md-table-head>
                            <md-table-head md-numeric v-if="$root.isDesktop">Adjustments</md-table-head>
                            <md-table-head md-numeric v-if="$root.isDesktop">Make Up</md-table-head>
                            <md-table-head md-numeric v-if="$root.isDesktop">Pro Rata Minimum</md-table-head>
                            <md-table-head md-numeric v-if="$root.isDesktop">Minimum</md-table-head>
                            <md-table-head md-numeric v-if="$root.isDesktop">Subtotal</md-table-head>
                            <md-table-head md-numeric v-if="$root.isDesktop">Tax</md-table-head>
                            <md-table-head md-numeric>Total</md-table-head>
                            <md-table-head v-if="$root.isDesktop">Status</md-table-head>
                            <md-table-head v-if="$root.isDesktop && !isReadOnlyUser">Actions</md-table-head>
                        </md-table-row>

                        <md-table-row v-for="invoice in invoicesList" :key="invoice.invoiceId">
                            <md-tooltip
                                class="on-hold-tooltip"
                                v-if="invoice.status === onHoldStatus"
                                v-html="onHoldToolTip(invoice.onHoldUntilDate)"
                            />
                            <md-table-cell>
                                <md-checkbox
                                    v-if="invoice.status !== onHoldStatus"
                                    class="shipment-checkbox"
                                    :value="invoice.teamMemberInvoiceId"
                                    v-model="selectedTeamMemberInvoiceIds"
                                ></md-checkbox>
                            </md-table-cell>
                            <md-table-cell v-if="!$root.isDesktop">
                                <payment-status-button :show-mobile-style="true" :invoice-details="invoice" />
                            </md-table-cell>
                            <md-table-cell>
                                <router-link
                                    class="invoice-ref"
                                    :to="{
                                        name: 'Team Member Invoice Details',
                                        params: { invoiceId: invoice.teamMemberInvoiceId }
                                    }"
                                    target="_blank"
                                >
                                    {{ invoice.invoiceNumber }}
                                </router-link>
                            </md-table-cell>
                            <md-table-cell v-if="$root.isDesktop">{{ invoice.teamMember.fullName }}</md-table-cell>
                            <md-table-cell md-numeric v-if="$root.isDesktop">
                                {{ invoice.totalAdjustments | currency(invoice.currency) }}
                            </md-table-cell>
                            <md-table-cell md-numeric v-if="$root.isDesktop">
                                {{ invoice.totalMinimumPay | currency(invoice.currency) }}
                            </md-table-cell>
                            <md-table-cell md-numeric v-if="$root.isDesktop">
                                {{ invoice.proRataAmount | currency(invoice.currency) }}
                            </md-table-cell>
                            <md-table-cell md-numeric v-if="$root.isDesktop">
                                {{ invoice.weeklyMinimum | currency(invoice.currency) }}
                            </md-table-cell>
                            <md-table-cell md-numeric v-if="$root.isDesktop">
                                {{ invoice.subTotal | currency(invoice.currency) }}
                            </md-table-cell>
                            <md-table-cell md-numeric v-if="$root.isDesktop">
                                {{ invoice.totalTax | currency(invoice.currency) }}
                            </md-table-cell>
                            <md-table-cell md-numeric>{{ invoice.total | currency(invoice.currency) }}</md-table-cell>
                            <md-table-cell v-if="$root.isDesktop">
                                <payment-status-button :invoice-details="invoice" :disabled="true" />
                            </md-table-cell>
                            <md-table-cell v-if="!isReadOnlyUser">
                                <approve-invoice-button
                                    v-if="!isReadOnlyUser && invoice.status !== onHoldStatus"
                                    :invoice-id="invoice.teamMemberInvoiceId"
                                    @invoiceApproved="handleApproveInvoice"
                                />

                                <send-draft-invoice-button
                                    v-if="!isReadOnlyUser && !isTeamMember && invoice.status !== onHoldStatus"
                                    v-feature="FEATURE_NAMES.TeamMemberInvoiceDraftApproval"
                                    :invoice-id="invoice.teamMemberInvoiceId"
                                    :last-draft-sent-time="invoice.lastDraftEmailDateSent"
                                    :draft-has-been-sent="invoice.draftEmailHasBeenSent"
                                    :new-draft-cost-added="invoice.newDraftCostAdded"
                                />

                                <generate-pdf-button
                                    v-if="!isReadOnlyUser"
                                    :invoice-id="invoice.teamMemberInvoiceId"
                                    :payment-summary="true"
                                />

                                <generate-excel-button
                                    v-if="!isReadOnlyUser"
                                    :invoice-id="invoice.teamMemberInvoiceId"
                                />

                                <delete-invoice-button
                                    v-if="!isTeamMember"
                                    :invoice-id="invoice.teamMemberInvoiceId"
                                    @invoiceDeleted="handleDeleteInvoice"
                                />
                            </md-table-cell>
                        </md-table-row>

                        <md-table-row v-if="totals && invoicesList.length > 0">
                            <md-table-cell></md-table-cell>
                            <md-table-cell v-if="!$root.isDesktop"></md-table-cell>
                            <md-table-cell class="totals-bold">Totals</md-table-cell>
                            <!-- Team Member placeholder -->
                            <md-table-cell v-if="$root.isDesktop"></md-table-cell>
                            <!-- Adjustments total -->
                            <md-table-cell v-if="$root.isDesktop" md-numeric class="totals-bold">
                                {{
                                    totals.totalAdjustments
                                        | currency(invoicesList.length > 0 ? invoicesList[0].currency : null)
                                }}
                            </md-table-cell>
                            <!-- Make Up total -->
                            <md-table-cell v-if="$root.isDesktop" md-numeric class="totals-bold">
                                {{
                                    totals.totalMinimumPay
                                        | currency(invoicesList.length > 0 ? invoicesList[0].currency : null)
                                }}
                            </md-table-cell>
                            <!-- Pro Rata Minimum placeholder -->
                            <md-table-cell v-if="$root.isDesktop"></md-table-cell>
                            <!-- Minimum placeholder -->
                            <md-table-cell v-if="$root.isDesktop"></md-table-cell>
                            <!-- Subtotal -->
                            <md-table-cell v-if="$root.isDesktop" md-numeric class="totals-bold">
                                {{
                                    totals.subTotal
                                        | currency(invoicesList.length > 0 ? invoicesList[0].currency : null)
                                }}
                            </md-table-cell>
                            <!-- Tax -->
                            <md-table-cell v-if="$root.isDesktop" md-numeric class="totals-bold">
                                {{
                                    totals.totalTax
                                        | currency(invoicesList.length > 0 ? invoicesList[0].currency : null)
                                }}
                            </md-table-cell>
                            <!-- Total -->
                            <md-table-cell md-numeric class="totals-bold">
                                {{ totals.total | currency(invoicesList.length > 0 ? invoicesList[0].currency : null) }}
                            </md-table-cell>
                            <!-- Status, Actions placeholders -->
                            <md-table-cell v-if="$root.isDesktop"></md-table-cell>
                            <md-table-cell v-if="$root.isDesktop && !isReadOnlyUser"></md-table-cell>
                        </md-table-row>
                    </md-table>
                    <div v-if="invoicesList.length === 0 && !isListLoading">
                        <p class="no-result-message">No results matching your search/filter could be found.</p>
                    </div>
                    <div v-if="isListLoading" class="content-loader loading-position">
                        <fade-loader :loading="isListLoading" color="#333333" />
                        <span>LOADING</span>
                    </div>
                </div>
            </md-card>
            <md-card-actions class="page-footer" md-alignment="space-between" v-if="total >= pagination.perPage">
                <div class>
                    <p class="card-category">Showing page {{ pagination.currentPage }} of {{ maxPage }}</p>
                </div>
                <pagination
                    v-model="pagination.currentPage"
                    class="pagination-no-border pagination-success"
                    :per-page="pagination.perPage"
                    :total="total"
                    @change-page="handleChangePage($event, pagination.perPage)"
                />
            </md-card-actions>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';
import FadeLoader from 'vue-spinner/src/FadeLoader';
import { PAGINATION_DEFAULTS } from '@/utils/defaults';
import { GeneralMixin } from '@/mixins/GeneralMixin';
import { handleRequests, showErrorMessage } from '@/helpers';
import { Pagination } from '@/components';
import { DATE_TYPES, FEATURE_NAMES } from '@/utils/constants';
import {
    PaymentStatusButton,
    GeneratePdfButton,
    GenerateExcelButton,
    DeleteInvoiceButton,
    ApproveInvoiceButton,
    SendDraftInvoiceButton
} from './buttons';

export default {
    name: 'TeamMemberInvoicesDraft',
    mixins: [GeneralMixin],
    components: {
        Pagination,
        PaymentStatusButton,
        FadeLoader,
        GeneratePdfButton,
        GenerateExcelButton,
        DeleteInvoiceButton,
        ApproveInvoiceButton,
        SendDraftInvoiceButton
    },
    props: {
        filters: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            invoicesList: [],
            isListLoading: false,
            pagination: PAGINATION_DEFAULTS,
            isSelectAll: false,
            batchFilterList: [],
            maxPage: 1,
            selectedTeamMemberInvoiceIds: [],
            isDraft: true,
            FEATURE_NAMES,
            onHoldStatus: 'OnHold',
            totals: null
        };
    },
    computed: {
        currentPageMax() {
            const highBound = this.currentPageMin + this.pagination.perPage;
            return this.total < highBound ? this.total : highBound;
        },
        currentPageMin() {
            return this.pagination.perPage * (this.pagination.currentPage - 1);
        },
        total() {
            return this.pagination.total;
        },
        totalPages() {
            if (this.total > 0) {
                return Math.ceil(this.total / this.pagination.perPage);
            }
            return 1;
        },
        ...mapGetters({
            user: 'user/user',
            isReadOnlyUser: 'user/isReadOnlyUser',
            isTeamMember: 'user/isTeamMember'
        })
    },
    watch: {
        selectedTeamMemberInvoiceIds: {
            handler() {
                // Force parent to update when selection changes
                this.$emit('selectionChanged', this.selectedTeamMemberInvoiceIds.length);
            },
            deep: true
        },
        invoicesList: {
            handler() {
                // Force parent to update when list changes
                this.$emit('listChanged', this.invoicesList.length);
            },
            deep: true
        }
    },
    async mounted() {
        this.isListLoading = true;
        const currentPage = Number(this.$route.query.currentPage) || 1;
        if (currentPage) {
            this.pagination.currentPage = currentPage;
        }

        await this.handleChangePage(currentPage, this.pagination.perPage);
    },
    methods: {
        async getInvoicesList(pageNumber = 1, invoicesPerPage = 50) {
            try {
                this.invoicesList = [];
                this.isListLoading = true;
                const endpoint = `/api/team-member-invoices/search`;
                const paymentStatus = 'Draft';

                const response = await handleRequests(endpoint, {
                    params: {
                        paymentStatus,
                        pageNumber,
                        invoicesPerPage,
                        ...this.cleanFilters()
                    }
                });

                const { invoices, totalInvoices, batchFilters } = response.data;

                this.batchFilterList = batchFilters.map((item) => {
                    return { id: item.invoiceBatchId, label: this.formatDate(item.startDate, item.endDate) };
                });

                this.$emit('batchFilterUpdated', this.batchFilterList);

                this.invoicesList = invoices;

                this.pagination.total = totalInvoices || this.invoicesList.length;
                this.maxPage = Math.ceil(this.pagination.total / this.pagination.perPage);
            } catch (error) {
                const message = 'Error in getting the team member invoice list';
                showErrorMessage(this, message, error);
            } finally {
                try {
                    const hasBatchFilter = !!this.filters?.teamMemberInvoiceBatchId;
                    if (hasBatchFilter) {
                        await this.getTotals();
                    } else {
                        this.totals = null;
                    }
                } catch (e) {
                    this.totals = null;
                }
                this.isListLoading = false;
            }
        },
        async handleChangePage(currentPage = 1, perPage = 50) {
            this.pagination.currentPage = currentPage;
            this.pagination.perPage = perPage;
            this.$router.replace({ path: this.$route.path, query: { currentPage } });
            await this.getInvoicesList(currentPage, perPage);
        },
        async getTotals() {
            const endpoint = `/api/team-member-invoices/totals`;
            const response = await handleRequests(endpoint, {
                params: {
                    paymentStatus: 'Draft',
                    ...this.cleanFilters()
                }
            });
            this.totals = response?.data || null;
        },
        cleanFilters() {
            Object.keys(this.filters).forEach((e) => {
                if (!this.filters[e]) 
                    delete this.filters[e];
            });

            return this.filters;
        },
        formatDate(startDate, endDate) {
            const formattedStartDate = this.$options.filters.dateFormat(startDate, DATE_TYPES.standardDate);
            const formattedEndDate = this.$options.filters.dateFormat(endDate, DATE_TYPES.standardDate);

            return `${formattedStartDate} - ${formattedEndDate}`;
        },
        handleDeleteInvoice({ result, invoiceId }) {
            this.removeSelected(invoiceId);
            if (result) {
                const index = this.invoicesList.findIndex((x) => x.teamMemberInvoiceId === invoiceId);
                if (index > -1) {
                    this.invoicesList.splice(index, 1);
                    this.isSelectAll = false;
                }
            }
        },
        removeSelected(invoiceId) {
            const ndx = this.selectedTeamMemberInvoiceIds.findIndex((x) => x === invoiceId);
            if (ndx > -1) {
                this.selectedTeamMemberInvoiceIds.splice(ndx, 1);
                this.isSelectAll = false;
            }
        },
        handleApproveInvoice({ result, invoiceId }) {
            this.removeSelected(invoiceId);
            if (result) {
                const index = this.invoicesList.findIndex((x) => x.teamMemberInvoiceId === invoiceId);
                if (index > -1) {
                    this.invoicesList.splice(index, 1);
                    this.isSelectAll = false;
                }
            }
        },
        onSelectAll(value) {
            if (value) {
                this.invoicesList.forEach((invoice) => {
                    if (!invoice.onHold) {
                        this.selectedTeamMemberInvoiceIds.push(invoice.teamMemberInvoiceId);
                    }
                });
            } else {
                this.selectedTeamMemberInvoiceIds = [];
            }
        },
        handleBulkDelete({ result, ids }) {
            if (result) {
                const invoices = [...ids];
                invoices.forEach((invoiceId) => {
                    this.removeSelected(invoiceId);
                });

                this.handleChangePage(true);
            } else {
                const message = 'There was an error deleting the invoices';
                showErrorMessage(this, message);
            }
        },
        handleBulkApprove({ result, ids }) {
            if (result) {
                const invoices = [...ids];
                invoices.forEach((invoiceId) => {
                    this.removeSelected(invoiceId);
                });

                this.handleChangePage(true);
            } else {
                const message = 'There was an error approving the invoices';
                showErrorMessage(this, message);
            }
        },
        updateBulkDraftInvoice(invoiceIds) {
            invoiceIds.forEach((id) => {
                const invoice = this.invoicesList.find((inv) => inv.teamMemberInvoiceId === id);
                if (invoice) {
                    invoice.draftEmailHasBeenSent = false;
                    invoice.lastDraftEmailDateSent = moment().format(DATE_TYPES.standardDateTime);
                }
            });
        },
        onHoldToolTip(date) {
            const until = date
                ? `<b>${moment(date)
                    .add(1, 'days')
                    .format('MMM D, YYYY')}</b>`
                : '<b>indefinitely</b>';

            return `Team member is on hold during this date range. Invoice cannot be approved or emailed until ${until}.`;
        }
    }
};
</script>

<style lang="scss" scoped>
.checkbox-head {
    margin-top: 4px;
}
.totals-bold {
    font-weight: 600;
}

.invoice-ref {
    color: rgba(0, 0, 0, 0.87) !important;
}

.invoice-ref:hover {
    color: #2b93ff !important;
}

.no-result-message {
    text-align: center;
    margin-top: 45px;
    font-size: 16px;
}

::v-deep .md-table-cell {
    padding: 0px 8px;

    &:last-child {
        .md-table-cell-container {
            text-align: left !important;
            justify-content: flex-start;
        }
    }
}

::v-deep .md-table-row {
    &.zero-results {
        padding: 16px;
        text-align: center;
    }

    .custom-button-container .custom-a-blue a {
        color: rgba(0, 0, 0, 0.87);
    }
}

::v-deep .md-table-row:hover {
    background-color: #fafafa;
    cursor: pointer;
}

::v-deep .md-numeric {
    .md-table-cell-container {
        padding-right: 10px;
    }
}

.loading-position {
    left: 50%;
    top: 50%;
}

.table-margin {
    margin-bottom: 200px !important;
}

.bulk-section {
    position: absolute;
    top: -35px;
    width: 700px;
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
    text-align: center;
    background-color: #cfeefa;
    color: #2b93ff;
    font-weight: 400;
    padding: 5px 10px 5px 20px;
    > div {
        width: 40%;
        display: inline-block;
        vertical-align: middle;
        text-align: left;
    }
    > div:last-child {
        width: 60%;
        text-align: right;
        button {
            height: 30px;
            width: 30px;
            min-width: 30px;
        }
        .dropdown {
            width: 180px;
            background-color: #ff9800 !important;
            display: inline-block;
            text-align: center;
            color: #fff;
            text-transform: uppercase;
            font-size: 12px;
            height: 30px;
            line-height: 30px;
            margin-top: 6px;
            cursor: pointer;
        }
    }
}

.on-hold-tooltip {
    max-width: 400px;
    text-align: justify;
}
</style>
